import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Grid, Typography } from '@material-ui/core';
import FilesDropzone from './FilesDropzone';
import FileCard from './FileCard';
import { makeStyles } from '@material-ui/styles';
import FilePreview from 'src/components/FilePreview';
import { getFileType } from 'src/utils/file';
import { useSelector } from 'react-redux';

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(1.75)
  },
  rootCard: {
    backgroundColor: 'beige',
    width: '493px'
  },
  card: {
    marginLeft: theme.spacing(2),
    flexGrow: 1,
    display: 'flex',

    width: '100%',
    alignItems: 'center'
  },
  cardFileName: {
    flexGrow: 1,
    display: 'flex',
    width: '100%',
    marginRight: theme.spacing(2)
  },
  uploadCard: {
    backgroundColor: 'white'
  },
  documentBucket: {
    width: '100%',
    padding: theme.spacing(1, 4),
    border: '1px solid #d4d4d4',
    borderRadius: theme.spacing(0.75),

    '& legend': {
      marginLeft: theme.spacing(-1),
      padding: theme.spacing(0, 1)
    }
  },
  requiredLabel: {
    color: theme.palette.text.secondary
  }
}));

function Files({
  category,
  className,
  uploadComplete,
  claim,
  claimContactInformation,
  fromGlassSearchView,
  userEmail,
  userName,
  onSetUserEmail,
  onSetUserName,
  isGlassProcessor,
  ...rest
}) {
  const classes = useStyles();

  const [selectedFile, setSelectedFile] = useState(null);
  const { user } = useSelector(state => state.account);

  const openFilePreview = (file) => {
    const fileType = getFileType(file.claimDocumentName);
    setSelectedFile({
      src: file.blobSrc,
      name: file.claimDocumentName,
      type: fileType
    });
  }

  const closeFilePreview = () => {
    setSelectedFile(null);
  };

  return (
    <div className={clsx(classes.root, className)} {...rest}>
      <FilePreview file={selectedFile} onClose={closeFilePreview} />
      <Grid container spacing={2}>



        <Grid item key={'Photo Dropzone'} xs={12} style={{ overflowX: 'auto' }}>
          <fieldset className={classes.documentBucket}>
            <legend>
              <Typography variant="h5" color="textPrimary" pt={4} ml={4}>
                {'Photos'}
                {'  '}
              </Typography>
            </legend>
            {(!user || isGlassProcessor === true) && (
              <FilesDropzone
                uploadComplete={uploadComplete}
                subCategory={category}
                claim={claim}
                claimContactInformation={claimContactInformation}
                userEmail={userEmail}
                userName={userName}
                onSetUserEmail={onSetUserEmail}
                onSetUserName={onSetUserName}
                fromGlassSearchView={fromGlassSearchView}
                maxFilesCountForCategory={10}
                maxFilesCountToUpload={10}
              />
            )}


            <Grid style={{ marginTop: 0, marginBottom: 0 }} container spacing={1}>
              {category
                .map((file) => (
                  <Grid item xs={12} key={file?.claimDocumentId}>
                    <FileCard onClick={() => openFilePreview(file)} file={file} />
                  </Grid>
                ))}
            </Grid>
          </fieldset>
        </Grid>

      </Grid>
    </div>
  );
}

Files.propTypes = {
  className: PropTypes.string,
  claim: PropTypes.object,
  uploadComplete: PropTypes.func,
  claimContactInformation: PropTypes.object,
  fromGlassSearchView: PropTypes.bool,
  userEmail: PropTypes.string,
  userName: PropTypes.string,
  onSetUserEmail: PropTypes.func,
  onSetUserName: PropTypes.func,
  isGlassProcessor: PropTypes.bool,
  category: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
    subCategory: PropTypes.string,
    isRequired: PropTypes.bool,
    isMissingDocuments: PropTypes.bool,
    maxFileCount: PropTypes.number,
    attributeId: PropTypes.number,
    attributeGroupId: PropTypes.number,
    cvqParamId: PropTypes.number,
    reportId: PropTypes.number,
    attachments: PropTypes.arrayOf(PropTypes.shape({
      claimDocumentName: PropTypes.string,
      claimDocumentId: PropTypes.string
    }))
  })),
};

export default Files;
